import {SITE_SET_DATA} from "../actions/SiteActions";

const initialState = {
    lang: 'en',
    socialAuthStatus: false,
    signUpEnabled: true,
    facebookAppId: undefined,
    googleAppId: undefined,
};

export default function SiteReducer(state = initialState, action) {
    switch (action.type) {
        case SITE_SET_DATA:
            return {
                ...state,
                ...action.payload
            };
    }

    return state;
}